package com.bulut.mecitogullari.data.model

import kotlinx.serialization.Serializable

@Serializable
enum class AccountKind {
    /** Tedarikçi — biz ondan alırız, borçlanırız. */
    SUPPLIER,

    /** Müşteri — biz ona satarız, alacaklanırız. */
    CUSTOMER,
}

/** A material supplier or a customer account tracked on credit. */
@Serializable
data class Supplier(
    val id: String,
    val name: String,
    val kind: AccountKind = AccountKind.SUPPLIER,
    val phone: String = "",
    val notes: String = "",
    @Serializable(with = LongAsDoubleSerializer::class)
    val createdAtEpochMillis: Long,
)

@Serializable
enum class DebtEntryType {
    /** Malzeme alımı (tedarikçi) / satımı (müşteri) — bakiyeyi artırır. */
    PURCHASE,

    /** Ödeme (tedarikçi) / tahsilat (müşteri) — bakiyeyi azaltır. */
    PAYMENT,
}

/** One line of a purchase: ÇİVİ — 225 KG × 43 ₺ = 9.675 ₺ */
@Serializable
data class DebtItem(
    val name: String,
    val quantity: Double,
    val unit: String,
    /** KDV dahil birim fiyat. */
    val unitPrice: Double,
) {
    val total: Double get() = quantity * unitPrice
}

/**
 * One movement on a supplier account. Purchases carry [items] and their
 * [amount] equals the item totals; payments carry only [amount].
 */
@Serializable
data class DebtEntry(
    val id: String,
    val supplierId: String,
    val type: DebtEntryType,
    @Serializable(with = LongAsDoubleSerializer::class)
    val dateEpochMillis: Long,
    /** Teslim alan kişi ya da ödeme açıklaması. */
    val description: String = "",
    val items: List<DebtItem> = emptyList(),
    val amount: Double = 0.0,
)

/** Positive = borç (we owe the supplier). */
fun List<DebtEntry>.balance(): Double =
    sumOf { if (it.type == DebtEntryType.PURCHASE) it.amount else -it.amount }

val CommonUnits = listOf("Adet", "KG", "Torba", "Yevmiye", "Saat", "Paket", "Metre", "M²", "M³", "Ton", "Litre")
